// extracted by mini-css-extract-plugin
export default {"multiSelection":"styles_multiSelection__pYju1","list":"styles_list__LEO9t"};